import * as React from 'react';
import { useEffect, useState } from 'react';
import { Card, Table } from 'react-bootstrap';
import TableLayout from '../../../shared/layout/table/TableLayout';
import { ErrorToast } from '../../../utils/toasters';
import { ContollingService } from '../ControllingService';
import { IIncomingKpis } from '../../../model/controlling/Controlling';
import { IncomingKpisFilter } from './IncomingKpisFilter';
import { formatDate } from '../../../utils/Functions';
import { priceSplitter } from '../../../utils/helpers/NumberFormater';
import { ITableColumn } from '../../../shared/components/TableSkeleton';

export interface IIncomingKpisFilter {
    page: number;
    perPage: number;
    totalPages: number;
    id: string;
    date?: string;
}
const INCOMING_KPIS_COLUMNS: ITableColumn[] = [
    { label: 'ID' },
    { label: 'Date' },
    { label: 'Standard deferral' },
    { label: 'Long term deferral' },
    { label: 'Total deferral' },
];
export function IncomingKpis() {
    const [dataLoading, setDataLoading] = useState(true);
    const [incomingKpis, setIncomingKpis] = useState<IIncomingKpis[]>([]);

    const [filters, setFilters] = useState<IIncomingKpisFilter>({
        page: 1,
        perPage: 15,
        totalPages: 0,
        id: '',
        date: undefined,
    });
    const requestIdRef = React.useRef(0);

    useEffect(() => {
        setFilters(prev => ({ ...prev, page: 1 }));
        fetchIncomingKpis({ ...filters, page: 1 });
    }, []);

    const fetchIncomingKpis = (params: typeof filters, pageOverride?: number) => {
        const requestId = ++requestIdRef.current;
        setDataLoading(true);
        const page = pageOverride ?? params.page;

        ContollingService.getKpis({ ...params, page })
            .then(({ data, page: responsePage, count }: any) => {
                if (requestId !== requestIdRef.current) return;

                const totalPages = Math.ceil(count / params.perPage);
                if (totalPages > 0 && page > totalPages) {
                    fetchIncomingKpis({ ...params, page: 1 });
                    return;
                }
                setIncomingKpis(data);
                setFilters(prev => ({
                    ...prev,
                    page: responsePage,
                    totalPages,
                }));
            })
            .catch(err => {
                if (requestId === requestIdRef.current) ErrorToast(err);
            })
            .finally(() => {
                if (requestId === requestIdRef.current) setDataLoading(false);
            });
    };

    const handlePageChange = (page: number) => {
        fetchIncomingKpis(filters, page);
    };
    return (
        <>
            <Card
                className="mb-5 p-4"
                onKeyDown={(e: React.KeyboardEvent) => {
                    if (e.key === 'Enter') fetchIncomingKpis(filters);
                }}
            >
                <IncomingKpisFilter handleFilter={fetchIncomingKpis} setFilters={setFilters} filters={filters} />
            </Card>
            <TableLayout
                pagination={filters}
                listLength={incomingKpis.length}
                handlePages={handlePageChange}
                isLoading={dataLoading}
                dataName={'KPIs'}
                skeletonColumns={INCOMING_KPIS_COLUMNS}
                skeletonRows={filters.perPage}
            >
                <Table hover responsive>
                    <thead>
                        <tr>
                            {INCOMING_KPIS_COLUMNS.map(column => (
                                <th key={column.label} className={column.className}>
                                    {column.label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {incomingKpis.map(incomingKpi => (
                            <tr key={incomingKpi.id}>
                                <td>{incomingKpi?.id}</td>
                                <td>{formatDate(incomingKpi.date)}</td>
                                <td>{priceSplitter(incomingKpi?.standardDeferral ?? 0)} €</td>
                                <td>{priceSplitter(incomingKpi?.longTermDeferral ?? 0)} €</td>
                                <td>{priceSplitter(incomingKpi?.totalDeferral ?? 0)} €</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </TableLayout>
        </>
    );
}
